import { useContext } from 'react';
import { TenantContext } from '../../../context/tenant-context';
import { handleRequest } from '../quipli-service-client';
import { PeriodicCount, PeriodicRevenue, PeriodStatRequest } from './stats';
import { StatsParsers } from './stats-parsers';

export const useStatsApiV1 = () => {
  const { tenant, contextPath } = useContext(TenantContext);

  async function getPeriodicRevenue(request: PeriodStatRequest): Promise<PeriodicRevenue[]> {
    const config = {
      method: 'post',
      url: `${contextPath}quipli-service/v1/stats/periodicRevenue`,
      headers: {
        'X-Tenant': tenant,
      },
      data: request,
    };
    const resp = await handleRequest<StatsParsers.PeriodicRevenueJson[]>(config);
    return resp.map(StatsParsers.toPeriodicRevenue);
  }

  async function getPeriodicRegistrations(request: PeriodStatRequest): Promise<PeriodicCount[]> {
    const config = {
      method: 'post',
      url: `${contextPath}quipli-service/v1/stats/periodicRegistrations`,
      headers: {
        'X-Tenant': tenant,
      },
      data: request,
    };
    const resp = await handleRequest<StatsParsers.PeriodicCountJson[]>(config);
    return resp.map(StatsParsers.toPeriodicCount);
  }

  async function getPeriodicProductsAdded(request: PeriodStatRequest): Promise<PeriodicCount[]> {
    const config = {
      method: 'post',
      url: `${contextPath}quipli-service/v1/stats/periodicProductsAdded`,
      headers: {
        'X-Tenant': tenant,
      },
      data: request,
    };
    const resp = await handleRequest<StatsParsers.PeriodicCountJson[]>(config);
    return resp.map(StatsParsers.toPeriodicCount);
  }

  return { getPeriodicRevenue, getPeriodicRegistrations, getPeriodicProductsAdded };
};
